// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2IAtI","filesListContainer":"PosDisputesFiles_filesListContainer__2XiWr","filesButton":"PosDisputesFiles_filesButton__2k-Kx"};